import s from "./content.module.css";
import {Fragment} from "preact";
import {close, iconCopy} from "../../../assets";
import {useContent} from "./useContent";
import {Link} from "preact-router";

const Content = (props) => {
    // Destructured props
    const {
        setIsOpen,
        data
    } = props;

    // Component logic data
    const componentProps = useContent({
        setIsOpen,
        data
    });

    // Destructured component logic data
    const {
        copyCodeToClipboard
    } = componentProps;

    const hasDiscountPercentage = !!data.discountPercentage;

    // Formats the product href without the .html suffix
    const formattedHref = data.product.href ? data.product.href.split(".html")[0] : "";

    // Wrapped this inside a variable because its content is dynamic
    const bottomContent = data.type === "redirect" ? (
        <Link
            href={`/${formattedHref}`}
            className={`cta-popup-button ${s.redirectButton}`}
            style={{
                backgroundColor: data.colors.bottomText,
                color: data.colors.bottom,
                borderColor: data.colors.bottom,
            }}
        >
            {data.buttonText || `Saiba mais`}
        </Link>
    ) : (
        <Fragment>
            <button
                className={`${s.redirectButton}`}
                style={{
                    backgroundColor: data.colors.bottomText,
                    color: data.colors.bottom,
                    borderColor: data.colors.bottom,
                }}
            >
                {data.coupon}
            </button>
            <button
                className={`cta-popup-coupon ${s.copyButton}`}
                style={{
                    backgroundColor: "transparent",
                    color: data.colors.bottomText,
                    borderColor: data.colors.bottomText
                }}
                onClick={(e) => copyCodeToClipboard(e)}
            >
                <img
                    src={iconCopy}
                    alt="Clipboard icon"
                />
                {data.buttonText || `Copiar cupom e adicionar ao carrinho`}
            </button>
        </Fragment>
    );

    return (
        <Fragment>
            <div
                className={`bg-light-gray w-full relative z-0 font-museo rounded-3xl`}
                style={{
                    ...(data.colors.shadow && {
                        boxShadow: `0 0 80px 0 ${data.colors.shadow}`
                    })
                }}
            >
                {/* Close button */}
                <button
                    type="button"
                    className={`${s.closeButton}`}
                    onClick={() => setIsOpen(false)}
                >
                    <img
                        src={close}
                        alt="Close"
                    />
                </button>

                {/* Title pill */}
                <div
                    className={`${s.popUpTitle}`}
                    style={{
                        backgroundColor: data.colors.top,
                        color: data.colors.topText,
                    }}
                >
                    <h2>
                        {data.popUpTitle}
                    </h2>
                    <h3>
                        {data.popUpLabel}
                    </h3>
                </div>

                {/* Top */}
                <div
                    className={`pb-4 pt-12 px-4 md:px-12 text-center ${s.discountBlock} rounded-t-3xl ${!hasDiscountPercentage ? "hidden" : ""}`}
                    style={{
                        backgroundColor: data?.colors?.discount,
                    }}
                >
                    <h2 style={{
                        color: data?.colors?.highlightedText
                    }}>
                        {data?.discountPercentage}%
                    </h2>
                    <span>
                        de desconto
                    </span>
                </div>

                {/* Service */}
                <div
                    className={`px-4 md:px-12 text-center ${s.serviceBlock} ${hasDiscountPercentage ? "py-6" : "pb-6 pt-14 rounded-t-3xl"}`}
                    style={{
                        backgroundColor: data.colors.service
                    }}
                >
                    <h1>
                        {data.product.productName}
                    </h1>
                    <div className={`flex-col items-center text-center mt-3 ${data.product.price ? "flex" : "hidden"}`}>
                        {data.product.specialPrice && (
                            <p className={`${s.specialPrice}`}>
                                <span>
                                    R$
                                </span>
                                &nbsp;{data.product.price}
                            </p>
                        )}
                        <p className={`${s.price}`}>
                            <span>
                                R$
                            </span>
                            &nbsp;{data.product.specialPrice || data.product.price}
                        </p>
                    </div>
                </div>

                {/* Bottom */}
                <div
                    className={`py-6 rounded-b-3xl px-4 text-center flex flex-col flex-center items-center justify-center gap-y-3`}
                    style={{
                        backgroundColor: data.colors.bottom,
                        color: data.colors.bottomText
                    }}
                >
                    {bottomContent}
                </div>
            </div>
        </Fragment>
    )
}

export default Content;
